import React from 'react'
import { Typography } from '@material-ui/core'

import { SectionBlock } from '../SectionBlock'

import { useStyles } from './CreateMultidisciplinarySection.style'

const CreateMultidisciplinarySection = (sectionProps) => {
  const classes = useStyles()

  return (
    <SectionBlock
      containerClassName={classes.container}
      nextSectionId='frequentQuestionsSection'
      {...sectionProps}>
      <div className={classes.mainContainer}>
        <div className={classes.content}>
          <Typography className={classes.title}>
            CREÁ <span>EVENTOS</span>
            <br />
            <span>MULTIDISCIPLINA</span>
            <br />
            ASOCIÁNDOTE
            <br />
            CON OTROS
            <br />
            ORGANIZADORES.
          </Typography>
        </div>
        <div className={classes.sportImage} />
      </div>
    </SectionBlock>
  )
}

export default CreateMultidisciplinarySection
